var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons 24*24px",
    clipPath: "url(#clip0_8805_32882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2204 11.934H12.5429L12.3027 11.7024C13.1432 10.7247 13.6492 9.4554 13.6492 8.07461C13.6492 4.99571 11.1535 2.5 8.07461 2.5C4.99571 2.5 2.5 4.99571 2.5 8.07461C2.5 11.1535 4.99571 13.6492 8.07461 13.6492C9.4554 13.6492 10.7247 13.1432 11.7024 12.3027L11.934 12.5429V13.2204L16.2221 17.5L17.5 16.2221L13.2204 11.934ZM8.07461 11.934C5.93911 11.934 4.21527 10.2101 4.21527 8.07461C4.21527 5.93911 5.93911 4.21527 8.07461 4.21527C10.2101 4.21527 11.934 5.93911 11.934 8.07461C11.934 10.2101 10.2101 11.934 8.07461 11.934Z",
    fill: "#6D6D6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8805_32882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearchIcon);
export default __webpack_public_path__ + "static/media/global-search-icon.7c117f5ae2bb4a643509c66f116404de.svg";
export { ForwardRef as ReactComponent };